import axios, { AxiosError, isCancel } from 'axios';

import { URL_CONSTANTS } from '../../../../constants/urlConstants';
import { buildQueryString } from '../../../../utils/query.helper';
import { SOURCE } from '../constants/constants';
import apiService from '../../../../services/api.service';
export const getDashboardList = async (
  searchQuery,
  setLoading,
  setDashboardListData = () => {},
  source = null,
  updateDefaultDashboardId = () => {}
) => {
  try {
    setLoading(true);
    let newQueryString = Object.entries(searchQuery)
      .filter(([, value]) => Boolean(value) || value === 0)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
    if (source === 'home') {
      newQueryString = `${newQueryString}&isFromDashboard=1`;
    }
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/manage/list/available-dashboards?${newQueryString}`
    );
    setDashboardListData(response.data);
    const defaultDashboard = response?.data?.items?.find(
      record => record.is_default_dashboard
    );

    if (defaultDashboard) {
      updateDefaultDashboardId(defaultDashboard.dashboard_id);
    }
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

// Create Dashboard
export const createDashboard = async values => {
  try {
    const response = await axios.post(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/manage`,
      values
    );

    return {
      error: false,
      message: 'Dashboard created successfully',
      dashboardId: response?.data?.dashboard_id,
    };
  } catch (error) {
    return {
      error: true,
      message: error?.response?.data?.error ?? 'Create failed',
    };
  }
};
// Clone Dashboard
export const cloneDashboard = async (dashboard_id, values) => {
  try {
    const response = await axios.post(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/manage/${dashboard_id}/clone`,
      values
    );
    if (response) {
      return {
        error: false,
        message: 'Dashboard cloned successfully',
      };
    }
  } catch (error) {
    return {
      error: true,
      message: error?.response?.data?.error ?? 'Clone failed',
    };
  }
};

// Edit Dashboard

export const editDashboard = async (dashboard_id, values) => {
  try {
    const response = await axios.patch(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/manage/${dashboard_id}`,
      values
    );
    if (response) {
      return {
        error: false,
        message: 'Dashboard cloned successfully',
      };
    }
  } catch (error) {
    return {
      error: true,
      message: error?.response?.data?.error ?? 'Update failed',
    };
  }
};

// Get Widgets List
export const getWidgetsList = async (
  searchQuery,
  setLoading,
  setWidgetsListData
) => {
  try {
    setLoading(true);
    const newQueryString = Object.entries(searchQuery)
      .filter(([, value]) => Boolean(value) || value === 0)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/widget-templates/list/available-widgets?${newQueryString}`
    );
    setWidgetsListData(response.data);
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

// Get Dashboard Details
export const getDashboardDetails = async (
  dashboardId,
  setLoading,
  setDashboardData,
  setWidgetRendererData,
  setWidgetQuery,
  setWidgetFilterQuery,
  setApplyFilters,
  setDashboardName
) => {
  try {
    setLoading(true);
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/manage/${dashboardId}`
    );

    setDashboardData(response?.data?.widgets);
    setWidgetQuery(response?.data?.widgets);

    if (setDashboardName) setDashboardName(response?.data);
    if (response?.data?.widgets?.length && response.status === 200) {
      let cubeQuery = response?.data?.widgets
        .map(widget =>
          widget?.widget_template?.widget_display_type !==
            'external-button-link' &&
          widget?.widget_template?.data_source?.length
            ? {
                data_source: widget?.widget_template?.data_source?.[0],
                widget_template_id: widget?.widget_template?.widget_template_id,
              }
            : null
        )
        .filter(query => query !== null);

      if (cubeQuery?.length) {
        getWidgetRendererData(
          cubeQuery,
          setWidgetRendererData,
          setLoading,
          setApplyFilters
        );
      }
    }
    if (setWidgetFilterQuery) setWidgetFilterQuery(response?.data?.widgets);
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

// Get Cube Data
export const getWidgetRendererData = async (
  widgetQuery,
  setWidgetRendererData,
  setLoading,
  setApplyFilters
) => {
  try {
    setLoading(true);
    let widgetRendererData = [];
    let widgetDataSource;
    if (widgetQuery?.length) {
      widgetDataSource = widgetQuery?.map(widget => widget.data_source);
    }
    widgetDataSource[0].limit = 1000;
    widgetRendererData = await axios.post(
      `${URL_CONSTANTS.API.BASE_URL}/cube/data-multi-queries`,
      widgetDataSource,
      {
        headers: {
          Authorization: localStorage.getItem('cubejsAuthorizationToken'),
        },
      }
    );

    let widgetData = widgetRendererData?.data?.map((rendererData, index) => {
      return {
        data: rendererData,
        widgetTemplateId: widgetQuery[index]?.widget_template_id,
      };
    });

    setWidgetRendererData(widgetData);
    return widgetData;
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
    if (setApplyFilters) setApplyFilters(false);
  }
};

// Get Cube Data and add widget to dashboard
export const addWidgetWithCubeData = async (
  cubeQuery,
  dashboardId,
  history,
  setWidgetRendererData,
  setWidgetQuery,
  setDialogOpen,
  setLoading,
  deleteWidgetIds = []
) => {
  setLoading(true);

  try {
    const newcubeQuery = cubeQuery.filter(
      item => !deleteWidgetIds.includes(item?.widget_id)
    );
    setWidgetQuery(newcubeQuery);
    if (newcubeQuery?.length) {
      let updatedCubeQuery = newcubeQuery
        .map(widget => {
          if (
            widget?.chart_type !== 'external-link-button' &&
            widget?.widget_template?.data_source !== undefined &&
            widget?.widget_template?.data_source?.length
          ) {
            return {
              data_source: widget?.widget_template?.data_source[0],
              widget_template_id: widget?.widget_template?.widget_template_id,
            };
          }
        })
        .filter(query => query !== null && query !== undefined);

      if (updatedCubeQuery?.length) {
        getWidgetRendererData(
          updatedCubeQuery,
          setWidgetRendererData,
          setLoading
        );
      } else {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }

    history.push(`/admin/dashboard/edit/${dashboardId}`);
  } catch (error) {
    console.log(error);
  } finally {
    setDialogOpen(false);
  }
};

// Delete Dashboard

// Update Widgets
export const updateWidgets = async (
  isLayoutUpdate,
  layout,
  widget,
  history,
  setLoading,
  setDashboardData,
  setWidgetRendererData,
  setWidgetQuery,
  setUpdatedLayout,
  setDialogOpen
) => {
  try {
    setLoading(true);
    let patchObj;
    let widgetTemplateIds;

    if (isLayoutUpdate) {
      widgetTemplateIds = widget?.map(
        val =>
          val?.widget_template?.widget_template_id || val?.widget_template_id
      );
      const addWidgetResponse = await axios.post(
        `${URL_CONSTANTS.API.BASE_URL}/dashboard/widgets`,
        {
          dashboard_id: widget[0]?.dashboard_id,
          widget_templates: widgetTemplateIds,
        }
      );
      if (addWidgetResponse?.data?.widgets) {
        patchObj = layout.map((lay, index) => {
          return {
            widget_id: addWidgetResponse?.data?.widgets?.filter(
              wid =>
                wid?.widget_template?.widget_template_id ===
                widget[index]?.widget_template?.widget_template_id
            )?.[0]?.widget_id,
            dashboard_id: widget[index]?.dashboard_id,
            name: widget[index]?.name,
            description: widget[index]?.description,
            width: isLayoutUpdate ? lay?.w : widget[index]?.width,
            height: isLayoutUpdate ? lay?.h : widget[index]?.height,
            x_axis_position: isLayoutUpdate
              ? lay?.x
              : widget[index]?.x_axis_position,
            y_axis_position: isLayoutUpdate
              ? lay?.y
              : widget[index]?.y_axis_position,
            index: isLayoutUpdate ? lay?.i : widget[index]?.index,
            chart_type: widget[index]?.chart_type || 'bar_chart',
            custom_properties: widget[index]?.custom_properties || {},
          };
        });
      }
    } else {
      widgetTemplateIds = [widget?.widget_template?.widget_template_id];
      const addWidgetResponse = await axios.post(
        `${URL_CONSTANTS.API.BASE_URL}/dashboard/widgets`,
        {
          dashboard_id: widget?.dashboard_id,
          widget_templates: widgetTemplateIds,
        }
      );
      if (addWidgetResponse?.data?.widgets) {
        patchObj = [
          {
            widget_id: addWidgetResponse?.data?.widgets?.filter(
              wid =>
                wid?.widget_template?.widget_template_id ===
                widget?.widget_template?.widget_template_id
            )?.[0]?.widget_id,
            dashboard_id: widget?.dashboard_id,
            name: widget?.name,
            description: widget?.description,
            width: layout[0]?.w,
            height: layout[0]?.h,
            x_axis_position: layout[0]?.x,
            y_axis_position: layout[0]?.y,
            index: widget?.index,
            chart_type: widget?.chart_type,
            custom_properties: widget?.custom_properties,
          },
        ];
      }
    }
    if (Array.isArray(patchObj) && patchObj.length) {
      const response = await axios.patch(
        `${URL_CONSTANTS.API.BASE_URL}/dashboard/widgets/multi-edit`,
        patchObj
      );

      if (response?.data?.status) {
        if (isLayoutUpdate) {
          history.push(`/admin/dashboard/view/${patchObj[0]?.dashboard_id}`);
        } else {
          setDialogOpen(false);
          getDashboardDetails(
            widget?.dashboard_id,
            setLoading,
            setDashboardData,
            setWidgetRendererData,
            setWidgetQuery,
            ''
          );
        }
      }
    } else throw new Error('payload is not an array');
  } catch (error) {
    console.log(error);
  } finally {
    setUpdatedLayout([]);
    setLoading(false);
  }
};

// Delete Widget
export const deleteWidget = async (
  widgetId,
  toast,
  id,
  setLoading,
  setDashboardData,
  setWidgetRendererData,
  setWidgetQuery
) => {
  setLoading(true);
  try {
    const response = await axios.delete(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/widgets/${widgetId}`
    );
    if (response) {
      toast.current?.show({
        severity: 'success',
        summary: 'Widget deleted successfully',
        life: 1500,
      });

      getDashboardDetails(
        id,
        setLoading,
        setDashboardData,
        setWidgetRendererData,
        setWidgetQuery
      );
      return response;
    }
  } catch (error) {
    console.log(error);
  }
};

export const fetchDashboardList = async (searchQuery, source) => {
  try {
    let newQueryString = buildQueryString(searchQuery);
    if (source === SOURCE.HOME) {
      newQueryString = `${newQueryString}&isFromDashboard=1`;
    }
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/manage/list/available-dashboards?${newQueryString}`
    );

    return {
      error: false,
      message: 'Dashboard list fetched successfully',
      dashboardList: response?.data,
    };
  } catch (error) {
    console.log(error);
    return {
      error: true,
      message: error?.response?.data?.error,
      dashboardList: null,
    };
  }
};

export const deleteDashboard = async dashboardId => {
  try {
    const response = await axios.delete(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/manage/${dashboardId}`
    );
    if (response) {
      return {
        error: false,
        message: 'Dashboard deleted successfully',
      };
    }
  } catch (error) {
    return {
      error: true,
      message: error?.response?.data?.error,
    };
  }
};

export const fetchWidgetsList = async searchQuery => {
  try {
    const response = await apiService.get(
      apiService.formatUrl(
        URL_CONSTANTS.DASHBOARD_PAGE.widgetsList,
        searchQuery
      )
    );

    return {
      error: false,
      message: 'Successfully fetched Widgets List',
      widgetsList: response?.items || [],
      count: response?.count || 0,
    };
  } catch (error) {
    if (isCancel(error)) {
      return {};
    }
    console.error('Error fetching Widgets List', error);
    return {
      error: true,
      message:
        error instanceof AxiosError
          ? error?.response?.data?.error
          : 'Error fetching Widgets List',
      widgetsList: [],
      count: 0,
    };
  }
};

export const updateWidgetReportLastVisitInfo = async widgetId => {
  try {
    await axios.post(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/widgets/last-visited-widget-report/${widgetId}`
    );
  } catch (error) {
    console.error('Error updating widget report last visit info', error);
    return {
      error: true,
      message:
        error?.response?.data?.error ||
        'Error updating widget report last visit info!',
    };
  }
};

export const getDashboardFilterConfig = async dashboardId => {
  try {
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/widgets-filter-config/${dashboardId}`
    );
    return {
      error: false,
      data: response?.data,
    };
  } catch (error) {
    return {
      error: true,
      data: null,
      message:
        error?.response?.data?.error ||
        'Error fetching dashboard filter configuration',
    };
  }
};

export const updateDashboardFilterConfig = async (dashboardId, payload) => {
  try {
    const response = await axios.patch(
      `${URL_CONSTANTS.API.BASE_URL}/dashboard/widgets-filter-config/${dashboardId}`,
      payload
    );
    return {
      error: false,
      data: response?.data,
      message:
        response?.data?.message || 'Filter configuration saved successfully',
    };
  } catch (error) {
    return {
      error: true,
      data: null,
      message:
        error?.response?.data?.error ?? 'Failed to save filter configuration',
    };
  }
};
